import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MultiSelectChecklistComponent } from './multi-select-checklist.component';
import { CheckboxComponent } from './checkbox.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
    exports: [
        MultiSelectChecklistComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        TranslateModule,
        MultiSelectChecklistComponent,
        CheckboxComponent
    ]
})
export class MultiSelectChecklistModule { }
